import { capitaliseFirst } from "core/model/utils/strings";
import StepMenu from "ds_legacy/components/StepMenu";
import Step from "ds_legacy/components/StepMenu/Step";
import { useAcpNavigationHandlers } from "dsl/hooks";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AccountPage from "./AccountPage";
import GroupPage from "./GroupPage";
import SessionPage from "./SessionPage";
import { PageWrapper } from "./shared";

const STEPS = ["account", "sender", "receiver", "patient", "request", "file"];
const DEFAULT_PAGE = STEPS[0];

export default function AcpSealdDebug() {
  const navigationHandlers = useAcpNavigationHandlers();
  const navigate = useNavigate();
  const { page = DEFAULT_PAGE } = useParams<{ page: string }>();
  const activeStep = STEPS.findIndex((step) => step === page);

  useEffect(() => {
    if (activeStep === -1) {
      navigate(`/acp/dashboard/sealddebug/${DEFAULT_PAGE}`, { replace: true });
    }
  }, [activeStep, page, navigate]);

  const StepPage = useMemo(() => {
    if (activeStep === -1) return null;
    let PageComponent;
    switch (page) {
      case "account":
        PageComponent = () => <AccountPage />;
        break;
      case "sender":
      case "receiver":
        PageComponent = () => <GroupPage page={page} />;
        break;
      case "request":
      case "patient":
      case "file":
        PageComponent = () => <SessionPage page={page} />;
        break;
      default:
        return null;
    }
    return (
      <PageWrapper page={page}>
        <PageComponent />
      </PageWrapper>
    );
  }, [activeStep, page]);

  return (
    <>
      <div className="flex justify-center">
        <StepMenu
          activeStep={activeStep}
          renderStep={(step, index) => (
            <Step
              active={index === activeStep}
              onClick={() => {
                navigationHandlers.goToSealdDebug(step);
              }}
            >
              {capitaliseFirst(step)}
            </Step>
          )}
          steps={STEPS}
        />
      </div>
      {StepPage}
    </>
  );
}
